import { useEffect, useState } from 'react';
import ApartmentIcon from '@mui/icons-material/Apartment'
import { IconButton, Menu, MenuItem, Divider, ListItemIcon, ListItemText, CircularProgress, Grid } from '@mui/material'
import SyncIcon from '@mui/icons-material/Sync';
import { useSearcherStore } from '../../../hooks/useSearcherStore';
import { useDrawerStore } from '../../../hooks/useDrawerStore';

const datasupplier = [
    { id: 1, rut: '444323355-5', name_rz: 'Tokio alarm'},
]

export const ChangeTypeList = (props) => {

    const { setDrawerSelectCustomer, setDrawerSelectSalesman } = useDrawerStore();

    const [openMenu, setOpenMenu] = useState<any>(null);
  
    const handleOpen = (event) => {
      setOpenMenu(event.currentTarget);
    };

    return (
        <>
        <IconButton onClick={handleOpen}>
            <ApartmentIcon sx={{fontSize:'22px'}} />
        </IconButton>
        <Menu
          id="basic-menu"
          open={Boolean(openMenu)}
          anchorEl={openMenu}
          onClose={()=>{setOpenMenu(null)}}
          MenuListProps={{
          'aria-labelledby': 'basic-button',
          }}
        >
          <div style={{paddingInline: "1rem"}}>
            <MenuItem onClick={()=>{}}>
                <ListItemText primary="Buscar por" />
            </MenuItem>
            <Divider/>
            <MenuItem onClick={() => {setDrawerSelectCustomer(true); setOpenMenu(null)}}>
                {'Clientes'}
            </MenuItem>
            <MenuItem onClick={() => {setDrawerSelectSalesman(true); setOpenMenu(null)}}>
                {'Vendedores'}
            </MenuItem>
          </div>
        </Menu>
        </>
    )
}